var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Table',{attrs:{"headers":_vm.headers,"data":_vm.data},on:{"row-click":_vm.editEmployee}})
}
var staticRenderFns = []

export { render, staticRenderFns }